import React, { Component } from 'react'
import { Button, Form, Grid, Segment } from 'semantic-ui-react'
import { COOKIE_DNS, COOKIE_EXPIRE_TIME, API_URL_FRONT } from '../constants/config'
import '../styles/main.scss'
import image from '../assets/images/login-img.jpg';
import logo from "../assets/images/login-logo.png";
import Cookies from 'js-cookie';
import _ from 'lodash';

export default class LoginCmp extends Component {

    constructor(props) {
        super(props)
        this.listener = null

        this.state = {
            hidden: true,
            submitted: false,
            components: {
                username: { value: '', name: 'username', label: 'USUARIO', error: undefined },
                password: { value: '', name: 'password', label: 'CONTRASEÑA', error: undefined },
            }
        };
        this.toggleShow = this.toggleShow.bind(this);

        this.listener = event => {
            if (event.code === "Enter" || event.code === "NumpadEnter") {
                document.getElementById("login").click();
            }
        };
        document.addEventListener("keydown", this.listener);
    }
    componentDidUpdate(prevProps) {

        if (this.state.submitted === true && this.props.loginStatus === "ERROR") {
            this.setState({ showSpinner: false })
            let newState = this.state.components;
            //console.log("newState: ", newState)
            newState["username"].error = true
            newState["password"].error = true
            this.setState({ components: newState })
            this.setState({ submitted: false })
            this.setState({ errorMessage: true })
        }

        if (prevProps.loginResponse !== this.props.loginResponse && this.props.loginStatus === 'SUCCESS') {
            console.log('[LoginCmp] loginResponse que va a setCookies:', JSON.stringify({
                tipoAgente: this.props.loginResponse?.tipoAgente,
                isImpersonalised: this.props.loginResponse?.isImpersonalised,
                agentCode: this.props.loginResponse?.agentCode,
                codigoAgenteImpersonalizado: this.props.loginResponse?.codigoAgenteImpersonalizado,
                access_token: this.props.loginResponse?.access_token
            }));
            console.log("login ok")

            document.removeEventListener("keydown", this.listener);
            //let account = this.props.loginResponse
            //account.roles = [];
            //account.token = account.access_token;
            //console.log("account: ", account)
            //Cookies.set('account', JSON.stringify(account).toString())
            this.setState({ showSpinner: false })
            //window.parent.postMessage({message: 'login', token: ""},'*')
            this.setCookies(this.props.loginResponse)

        }

    }

    setCookies(cookies) {

        //console.log("cookies: ", cookies)

        let rolesFiltrados
        let rolesCookies = cookies.authorities

        rolesFiltrados = rolesCookies.filter(function (item) {
            if (item.authority.startsWith("SHOW_MENU_")) {
                return item
            }
        })

        rolesCookies = rolesCookies.filter(function (item) {
            if (!item.authority.startsWith("SHOW_MENU_")) {
                return item
            }
        })

        let apiRoles = rolesCookies.filter(item => item.authority.startsWith("API_"));
        let cookieRoles = rolesCookies.filter(item => !item.authority.startsWith("API_"));

        cookieRoles = cookieRoles.filter(item =>
            !item.authority.includes("ADDLEAD")
        );

        // const MAX_ROLES = 63;

        // cookieRoles = cookieRoles.slice(0, MAX_ROLES);

        // localStorage.setItem('userRoles_API', JSON.stringify(apiRoles));
        function getValidCookieDomain() {
            if (typeof window === 'undefined') return undefined;
            const hostname = window.location.hostname;
            if (!hostname || hostname === 'localhost' || hostname === '127.0.0.1') {
                return undefined;
            }
            if (COOKIE_DNS && hostname.includes('colonseguros.com.ar')) {
                return COOKIE_DNS;
            }
            return undefined;
        }

        // Almacenar todos los roles completos en localStorage
        localStorage.setItem('menuPermissions', JSON.stringify(rolesFiltrados));
        localStorage.setItem('userRoles', JSON.stringify(rolesCookies));

        cookies.token = cookies.access_token;
        cookies.authorities = [];
        cookies.roles = [];

        // Guardar todos los roles completos en localStorage
        const cleanRoles = _.uniqBy((cookieRoles || []).map(item => ({ authority: item.authority })), 'authority');
        cleanRoles.sort((a, b) => {
            const isPriorityA = a.authority.startsWith('ROLE_');
            const isPriorityB = b.authority.startsWith('ROLE_');
            if (isPriorityA && !isPriorityB) return -1;
            if (!isPriorityA && isPriorityB) return 1;
            return a.authority.localeCompare(b.authority);
        });

        cookies.token = cookies.access_token;
        cookies.authorities = [];
        cookies.roles = [];
        cookies.userRoles = cleanRoles;
        cookies.codigoAgente = cookies.agentCode;
        cookies.nombre = cookies.agentName;

        var expireDate = new Date();
        var time = expireDate.getTime();
        var expireTime = time + COOKIE_EXPIRE_TIME;
        expireDate.setTime(expireTime);
        let cookiePayload = { ...cookies };
        if (cookiePayload.agentCode && cookiePayload.codigoAgenteLogueado &&
            cookiePayload.agentCode !== cookiePayload.codigoAgenteLogueado) {
            cookiePayload.codigoAgenteImpersonalizado = cookiePayload.agentCode;
            cookiePayload.isImpersonalised = true;
            cookiePayload.isImpersonalized = true;
        }

        // Eliminar campos que no consumen los servicios para no exceder los 4096 bytes del navegador
        delete cookiePayload.impersonalizado;
        delete cookiePayload.refresh_token;
        delete cookiePayload.credentials;
        delete cookiePayload.scope;
        cookiePayload.authorities = [];
        cookiePayload.roles = [];
        cookiePayload.userRoles = [...cleanRoles];

        // El límite estricto de los navegadores por cookie es 4096 bytes (RFC 6265).
        // Si el payload codificado excede 3700 bytes, recortamos roles desde el final hasta que quepa.
        while (encodeURIComponent(JSON.stringify(cookiePayload)).length > 3700 && cookiePayload.userRoles.length > 10) {
            cookiePayload.userRoles.pop();
        }

        console.log("cookiePayload: ", cookiePayload);

        const cookieDomain = getValidCookieDomain();
        const cookieOptions = { path: '/', expires: expireDate, ...(cookieDomain ? { domain: cookieDomain } : {}) };

        // Remover cookies existentes en todas las rutas y variantes de dominio
        Cookies.remove('account', { path: '/', ...(cookieDomain ? { domain: cookieDomain } : {}) });
        Cookies.remove('accountSIP', { path: '/', ...(cookieDomain ? { domain: cookieDomain } : {}) });
        Cookies.remove('account', { path: '/' });
        Cookies.remove('accountSIP', { path: '/' });
        Cookies.remove('account');
        Cookies.remove('accountSIP');

        console.log('[setCookies] token que se va a guardar:', cookiePayload.access_token);
        console.log('[setCookies] agentCode:', cookiePayload.agentCode);
        console.log('[setCookies] isImpersonalised:', cookiePayload.isImpersonalised);

        const cookieString = JSON.stringify(cookiePayload);
        const encoded = encodeURIComponent(cookieString.replace("%25", "%"));
        console.log('[setCookies] roles en cookie:', cookiePayload.userRoles.length, '| longitud cookiePayload (bytes):', cookieString.length, '| longitud encoded:', encoded.length, '| domain:', cookieDomain || '(host-only)');

        // Payload liviano para accountSIP (usado por SIP Java ColonCookies.java para extraer el token)
        const sipPayload = {
            token: cookiePayload.token || cookiePayload.access_token,
            access_token: cookiePayload.access_token,
            codigoAgente: cookiePayload.agentCode || cookiePayload.codigoAgente,
            nombre: cookiePayload.agentName || cookiePayload.nombre,
            cuit: cookiePayload.cuit,
            tipoAgente: cookiePayload.tipoAgente,
            isImpersonalized: cookiePayload.isImpersonalized,
            userRoles: (cookiePayload.userRoles || []).slice(0, 15)
        };
        const sipEncoded = encodeURIComponent(JSON.stringify(sipPayload).replace("%25", "%"));

        Cookies.set('account', cookieString, cookieOptions);
        Cookies.set('accountSIP', sipEncoded, cookieOptions);

        // Fallback: si falló por restricción de dominio del navegador (ej. localhost), guardar sin domain
        if (!Cookies.get('account')) {
            console.warn('[setCookies] Cookies.set con dominio falló; aplicando fallback host-only');
            Cookies.set('account', cookieString, { path: '/', expires: expireDate });
            Cookies.set('accountSIP', sipEncoded, { path: '/', expires: expireDate });
        }

        console.log("COOKIES ACCOUNT: ", Cookies.getJSON("account") || Cookies.get("account"));
        console.log("COOKIES ACCOUNTSIP: ", Cookies.getJSON("accountSIP") || Cookies.get("accountSIP"));
        window.parent.postMessage({ message: 'login', token: JSON.stringify(cookies.token) }, '*');
        window.parent.postMessage({ message: 'menuPermissions', value: JSON.stringify(rolesFiltrados) }, '*');
    }

    handleChange(e) {
        const target = e.currentTarget;
        let currentState = this.state.components
        currentState[target.name].value = target.value
        currentState["username"].error = false
        currentState["password"].error = false
        this.setState({ components: currentState });
    }

    onClickLogin() {
        this.setState({ submitted: true, showSpinner: true })
        this.props.login({ username: this.state.components.username.value, password: this.state.components.password.value })
    }

    toggleShow() {
        this.setState({ hidden: !this.state.hidden });
    }

    render() {



        let errorMessage = <p className="login-error-message">Error de login. Compruebe sus datos e intente de nuevo.</p>

        return (
            <div className="login-container">

                <div >
                    <div className="title-container">
                        <div className="logo-container">
                            <a href="https://sep.colonseguros.com.ar"><img className="logoLogin" src={logo} alt="" /></a>
                        </div>
                        <div className="message-portal">
                            <p>Portal de Productores</p>
                        </div>
                    </div>
                </div>
                <div>
                    <Grid textAlign='center' className={"grid-container"} verticalAlign='top'>
                        <Grid.Column className={"form-container"} style={{ maxWidth: 700 }}>
                            <img className="imgLogin" src={image} alt="" />
                            <div className="input-container">
                                <div className="subtitle-container">
                                    <h3>Iniciar Sesión</h3>
                                    <p><label>Bienvenido a nuestro Portal de Productores.</label></p>
                                </div>
                                <Form size='large'>
                                    <Segment stacked>
                                        <Form.Input
                                            fluid icon='user'
                                            iconPosition={"left"}
                                            placeholder='Usuario'
                                            label='USUARIO'
                                            onChange={(e) => this.handleChange(e)}
                                            name={this.state.components.username.name}
                                            error={this.state.components.username.error}
                                        />
                                        <Form.Input
                                            fluid
                                            placeholder='Contraseña'
                                            label='CONTRASEÑA'
                                            type={this.state.hidden ? "password" : "text"}
                                            onChange={(e) => this.handleChange(e)}
                                            name={this.state.components.password.name}
                                            error={this.state.components.username.error}
                                            icon={<i className="eye icon icon-show-pass" onClick={() => this.toggleShow()} />}
                                        />

                                        {this.state.errorMessage === true ? errorMessage : null}
                                        <a className="link-olvide-password" href="https://seguros.colonseguros.com.ar/ov_consultas/#/recuperarContrasenia">¿Olvidaste tu contraseña?</a>
                                        <Button id="login" color='red' fluid size='large' onClick={() => this.onClickLogin()} type='button'>Ingresar</Button>
                                    </Segment>
                                </Form>
                            </div>
                        </Grid.Column>
                    </Grid>
                </div>

                <div className="ui relaxed grid footer">
                    <div className="three column row first-footer">
                        <div className="column footer-left"><a href="https://seguros.colonseguros.com.ar/ov_consultas/#/legales/politicas-privacidad">Política de privacidad del Sitio Web</a></div>
                        <div className="column footer-center"><a href="https://seguros.colonseguros.com.ar/ov_consultas/#/legales/terminosyCondiciones">Términos y Condiciones</a></div>
                        <div className="column footer-right"><a href="https://seguros.colonseguros.com.ar/ov_consultas/#/legales/derecho-acceso-disposicion">Derecho de acceso disposición DNPDP N°10/08</a></div>
                    </div>
                    <div className="sixteen wide column last-footer">
                        © {new Date().getFullYear()} Colón Seguros - Todos los derechos reservados.
                    </div>
                </div>

                {/**SPINNER**/}
                {<div className={this.state.showSpinner === true ? "show" : "not-show"}>
                    <div className={"ui active dimmer page-loading"}>
                        <div className="ui text loader">Por favor espere unos instantes...</div>
                    </div>
                </div>}
                {/**SPINNER**/}
            </div>
        );
    }
}